<template>
  <div :class="styles" class="flex items-center py-2 justify-between">
    <div class="flex items-center">
        <AccountPhoto :social="page.provider" :isGroupCover="groupHasCover" :isGroup="page.type === 'group'" :image_url="getPicture()"/>
        <div class="flex flex-col">
          <span class=" text-customGrayDark font-semibold">{{JSON.parse(page.metadata)['name']}}</span>
          <span class=" text-xs text-customGray font-light">{{type}}</span>
        </div>
    </div>
    
    <input class="appearance-none mr-4 focus:ring-0  checked:border-carolina checked:bg-carolina rounded-md text-carolina border-gray-300 w-6 h-6" 
      type="checkbox"
      v-model="page.active"
      @change="activeChanged" 
    />
  </div>
</template>

<script>
    import AccountPhoto from '@/components/scheduler/Common/AccountPhoto';
    import capitalize from '@/utils/capitalize';
    
    export default {
        name:"RowTag",

        props: {
          subtitle: {
            type: String,
            default: 'Page'
          },
          styles: {
            type: String,
            default: 'bg-white'
          },
          page: {
            type: Object,
            require: true
          },
        },
        
        components: {
            AccountPhoto,
        },

        data() {
          return {
            groupHasCover: false
          }
        },

        methods: {
          activeChanged() {
            let isActive = this.page.active;
            this.$emit('change-page', {pageId: this.page.id, active: isActive, provider: this.page.provider});
          },

          getPicture() {
            if(this.page.type === 'group') {
              let metadata = JSON.parse(this.page.metadata);
              if(metadata['cover'] && metadata['cover']['source']) {
                this.groupHasCover = true;
                return metadata['cover']['source'];
              } 

              return metadata['icon'];
            }

            return JSON.parse(this.page.metadata)['picture']['data']['url'];
          }
        },

        computed: {
          type: function() {
            if(this.page) {
              return capitalize(this.page.type);
            }

            return ''
          }
        }
    }
</script>